import React from "react";
import { Box } from "@chakra-ui/react";
import AboutUs from "../components/AboutUs";
import Realisations from "../components/Realisations";
import Activity from "../components/Activities";
import Solutions from "../components/Solutions";
import Contact from "../components/Contact";
import Implantations from "../components/Implantations";
import MapSite from "../components/MapSite";
import Chargement from "../components/Chargement";
import Zebi from "../components/Zebi";
import { I18nextProvider } from "react-i18next";
import i18n from "i18next";
import SideDrawer from "../components/navigation/NavBarComponent";
import ScrollToTopButton from "../components/ScrollToTopButton";
import { ReadingProgressBar } from "../components/ReadingProgressBar";
import SectionDivider from "../components/SectionDivider";

// ─── Palette de couleurs des sections ─────────────────────────────────────────
// Hero  (Zebi)        → transparent / pas de bg propre, le contenu scrolle dessus
// AboutUs             → #FAFAF7  (ivoire clair)
// Realisations        → #03111F  (bleu nuit)
// Activities          → #F4F3EF  (ivoire chaud)
// Solutions           → #03111F  (bleu nuit)
// Contact             → #FAFAF7  (ivoire clair)
// Implantations       → #03111F  (bleu nuit)
// MapSite             → #F4F3EF  (ivoire chaud)

export default function Home() {
    return (
        <I18nextProvider i18n={i18n}>
            <Box>
                <ReadingProgressBar />
                <Chargement />
                <SideDrawer />

                {/* ── Hero fixe ── */}
                <Box top="0" left="0" width="100%" zIndex="100">
                    <Zebi />
                </Box>

                {/* ── Contenu scrollable ── */}
                <Box mt="100vh">

                    {/* Hero → AboutUs */}
                    <SectionDivider fromColor="transparent" toColor="#FAFAF7" variant="diagonal" flip={false} height={120} />

                    <AboutUs />

                    {/* AboutUs → Réalisations */}
                    <SectionDivider fromColor="#FAFAF7" toColor="#03111F" variant="sharp" flip={false} height={120} />

                    <Realisations />

                    {/* Réalisations → Activities */}
                    <SectionDivider fromColor="#03111F" toColor="#F4F3EF" variant="diagonal" flip={true} height={120} />

                    <Activity />

                    {/* Activities → Solutions */}
                    <SectionDivider fromColor="#F4F3EF" toColor="#03111F" variant="sharp" flip={true} height={120} />

                    <Solutions />

                    {/* Solutions → Contact */}
                    <SectionDivider fromColor="#03111F" toColor="#FAFAF7" variant="diagonal" flip={false} height={120} />

                    <Contact />

                    {/* Contact → Implantations */}
                    <SectionDivider fromColor="#FAFAF7" toColor="#03111F" variant="sharp" flip={false} height={120} />

                    <Implantations />

                    {/* Implantations → MapSite */}
                    <SectionDivider fromColor="#03111F" toColor="#03111F" variant="diagonal" flip={true} height={120} />

                    <MapSite />

                    <ScrollToTopButton />
                </Box>
            </Box>
        </I18nextProvider>
    );
}